import { Inject, Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import { Solicitud } from '@/shared/model/solicitud.model';
import AlertService from '@/shared/alert/alert.service';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { Filtro, IFiltro } from '@/shared/model/filtro.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import SolucionService from '@/entities/solucion/solucion.service';
import { MotivosCatalogos } from '@/components/movimientos/registro-movimiento/motivos.catalog';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';

interface HeadTables {
  key: string;
  label: string;
  class: string;
  sortable?: boolean;
  formatter?: any;
}

@Component
export default class AcreditacionEvaluacionComponent extends mixins() {
  @Inject('alertService') protected alertService: () => AlertService;
  @Inject('solicitudService') public solicitudService: () => SolicitudService;
  @Inject('solucionService') public solucionService: () => SolucionService;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public acreditaciones = [];

  private readonly solucionAcreditaciones = '65d125c62368153b1e369c14';
  private readonly rizoma = 'Rizoma';
  private readonly apeiron = 'Apeiron';

  public cumpleAcreditacion: boolean = null;

  public rolOperador = false;

  public login = this.$store.getters.account?.login ?? '';

  public opcionesBoleanas: Array<any> = [];

  mounted(): void {
    if (this.solicitud) {
      this.cumpleAcreditacion = this.solicitud.cumpleAcreditacion;
      this.obtenerAcreditacionesApeiron();
      this.retrieveAllSolucionsByUser();
      this.opcionesBoleanas = MotivosCatalogos.OPCIONES_BOLEANAS;
      this.extraerAcreditacionRizoma();
    }
  }

  public tablaAcreditacionesApeiron: Array<HeadTables> = [
    { key: 'sistema', label: this.$t('bandejaAcreditaciones.sistema').toString(), class: 'text-center' },
    { key: 'accion', label: this.$t('bandejaAcreditaciones.acciones').toString(), class: 'text-center' },
  ];

  getComprobante(item) {
    if (item?.url != null) {
      return item.url;
    }
  }

  public retrieveAllSolucionsByUser(): void {
    const filtro = new Filtro();
    filtro.usuario = this.login;
    filtro.solucionId = this.solicitud.solucionId;
    const paginationQuery = {
      page: 0,
      size: 100,
      sort: ' id , desc ',
      filter: filtro,
    };
    this.solucionService()
      .retrieve(paginationQuery)
      .then(
        res => {
          if (res.data && res.data.length > 0) {
            this.rolOperador = true;
          }
        },
        err => {
          this.alertService().showHttpError(this, err.response);
        }
      );
  }

  public obtenerAcreditacionesApeiron(): void {
    const acreAp = { sistema: this.apeiron, url: null };
    const filtroSol: IFiltro = {};
    filtroSol.cvuSolicitante = this.solicitud.solicitante.cvu;
    filtroSol.solucionId = this.solucionAcreditaciones;
    filtroSol.estadosSolicitud = [
      EstadoSolicitud.APROBADA,
      EstadoSolicitud.EN_FIRMA,
      EstadoSolicitud.OPERACION_EN_PROCESO,
      EstadoSolicitud.FORMALIZADA,
    ];
    const paginationQuery = {
      page: -1,
      size: 100,
      sort: 'id,desc',
      filter: filtroSol,
    };
    this.solicitudService()
      .consultarSolicitudes(TipoSolucion.ACREDITACIONES, paginationQuery)
      .then(res => {
        const lastObject = res.data[res.data.length - 1];
        acreAp.url = lastObject.urlComprobante.uri;
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.alertService().showInfo(this, error.response.data.detail);
        }
      })
      .finally(() => this.acreditaciones.push(acreAp));
  }

  private extraerAcreditacionRizoma() {
    const itemRizoma = { sistema: this.rizoma, url: null };
    const acreditacion = this.solicitud?.SOLICITUD_RIZOMA?.acreditacion;

    if (acreditacion && acreditacion.length > 0) {
      const lastObject = acreditacion[acreditacion.length - 1];
      itemRizoma.url = lastObject.documento.uri;
    }

    this.acreditaciones.push(itemRizoma);
  }

  public guardarValidacionAcreditacion(): void {
    if (this.rolOperador) this.solicitud.cumpleAcreditacion = this.cumpleAcreditacion;
    this.solicitudService()
      .update(this.solicitud)
      .then(() => {
        this.alertService().showSuccess(this, this.$t('documentos.exito', 'Exitoso').toString());
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }
}
